(function () {
	const initSlider = (section) => {
		let sliders, horizontalSlider, slidersWrapper;

		if (document.currentScript) {
			sliders =
				document.currentScript.parentElement.querySelectorAll(".aic__marquee");
			horizontalSlider = document.currentScript.parentElement.querySelector(
				".aic__marquee-horizontal",
			);
			slidersWrapper =
				document.currentScript.parentElement.querySelector(".aic__marquees");
		} else {
			sliders = section.querySelectorAll(".aic__marquee");
			horizontalSlider = section.querySelector(".aic__marquee-horizontal");
			slidersWrapper = section.querySelector(".aic__marquees");
		}
		const evenSliders = [];
		const oddSliders = [];

		if (sliders.length > 0) {
			sliders.forEach((slider, i) => {
				if (i % 2 === 0) {
					oddSliders.push(slider);
				} else {
					evenSliders.push(slider);
				}
			});

			oddSliders.forEach((oddSlider) => {
				if (!oddSlider.querySelector(".js-marquee-wrapper")) {
					let duration = 50000;
					if (oddSlider.closest(".aic--right")) {
						duration = 40000;
					}
					oddSlider.classList.add("marquee-down");
					const $oddSlider = $(oddSlider);
					$oddSlider.marquee({
						delayBeforeStart: 0,
						direction: "down",
						allowCss3Support: true,
						startVisible: true,
						duplicated: true,
						duration: duration,
						gap: 0,
					});
				}
			});

			evenSliders.forEach((evenSlider) => {
				if (!evenSlider.querySelector(".js-marquee-wrapper")) {
					let duration = 50000;
					if (evenSlider.closest(".aic--right")) {
						duration = 40000;
					}
					evenSlider.classList.add("marquee-up");
					const $evenSlider = $(evenSlider);
					$evenSlider.marquee({
						delayBeforeStart: 0,
						direction: "up",
						allowCss3Support: true,
						startVisible: true,
						duplicated: true,
						duration: duration,
						gap: 0,
					});
				}
			});
		}

		if (horizontalSlider) {
			if (!horizontalSlider.querySelector(".js-marquee-wrapper")) {
				const width = horizontalSlider.scrollWidth;
				const speed =
					document.documentElement.clientWidth > 575
						? Math.round(document.documentElement.clientWidth * 0.03)
						: Math.round(document.documentElement.clientWidth * 0.08);
				horizontalSlider.classList.add("marquee");
				const $horizontalSlider = $(horizontalSlider);
				$horizontalSlider.marquee({
					delayBeforeStart: 0,
					direction: "left",
					allowCss3Support: true,
					startVisible: true,
					speed: speed,
					gap: 0,
				});

				let lastWidth = document.documentElement.clientWidth;
				const resizeObserve = new ResizeObserver((entries) => {
					const [entry] = entries;
					const width = entry.contentRect.width;
					if (Math.abs(width - lastWidth) < 40) return;
					lastWidth = width;
					const speed =
						width > 575 ? Math.round(width * 0.03) : Math.round(width * 0.08);
					$horizontalSlider.marquee("destroy");
					$horizontalSlider.marquee({
						direction: "left",
						allowCss3Support: true,
						startVisible: true,
						speed: speed,
						gap: 0,
					});
				});
				if (slidersWrapper) resizeObserve.observe(slidersWrapper);
			}
		}
	};

	const startMarquee = () => {
		const run = () => initSlider();
		if ("requestIdleCallback" in window) {
			requestIdleCallback(run, { timeout: 2500 });
		} else {
			setTimeout(run, 1500);
		}
	};

	if (document.readyState === "complete") {
		startMarquee();
	} else {
		window.addEventListener("load", startMarquee, { once: true });
	}

	document.addEventListener("shopify:section:load", function (section) {
		initSlider(section.target);
	});
	document.addEventListener("shopify:section:reorder", function (section) {
		initSlider(section.target);
	});
})();
